
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 35 35\" id=\"icon-social_gplus\" > <title>social_gplus</title> <g> <path d=\"M14.14,16.36h7.14v1.12a7.14,7.14,0,1,1-2.79-5.66l-1.36,1.77a4.91,4.91,0,1,0-3,8.8,4.92,4.92,0,0,0,4.78-3.8H14.14Z\"/> <polygon points=\"27.47 16.36 29.42 16.36 29.42 18.59 27.47 18.59 27.47 20.53 25.24 20.53 25.24 18.59 23.3 18.59 23.3 16.36 25.24 16.36 25.24 14.41 27.47 14.41 27.47 16.36\"/> <path d=\"M17.5,0A17.5,17.5,0,1,0,35,17.5,17.5,17.5,0,0,0,17.5,0Zm0,32.27A14.77,14.77,0,1,1,32.27,17.5,14.77,14.77,0,0,1,17.5,32.27Z\"/> </g> </symbol>";
module.exports = sprite.add(image, "icon-social_gplus");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/social_gplus.svg
 ** module id = 221
 ** module chunks = 24
 **/